<svelte:options customElement={{ tag: "bt-add-section-button", shadow: "none", }} />

<script lang="ts">
	import { type CuratedItem } from './curationTypes';

  export let contents: string;
  let contentsJSON: CuratedItem[] = JSON.parse(contents);
  export let curationId = 0;
  export let editable = contentsJSON[0]?.editable;
	export let addSectionText: string = "Section";

	let buttonDisabled = false;

	async function addNewSection(parentCurationId: number, position: number) {
		// Prevent double-clicks from spawning 2 sections
		if (buttonDisabled) return;
		buttonDisabled = true;
		window.setTimeout(() => {
			buttonDisabled = false;
		}, 1000);

    const newSectionData = {
      "curation": {
        "parent_curation": parentCurationId,
        "position": position
      }
    }

    const response = await fetch(`/curations`, {
      method: 'POST',
      credentials: 'same-origin',
      // @ts-ignore
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // @ts-ignore
        'X-CSRF-Token': document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content')
      },
      body: JSON.stringify(newSectionData)
    });

    if (response.ok) {
      window.location.reload();
    }
  }

</script>

{#if editable}
  <button
    on:click={() => addNewSection(curationId, 0)}
    class="font-normal text-base text-black hover:text-neutral-500"
  >
    <p>{addSectionText}</p>
  </button>
{/if}
